import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createMaterialAsync, deleteMaterialAsync, getAllMaterialByWorkOrderIdAsync, getHoursAndMaterialByIDAsync, updateBulkMaterialAsync, updateMaterialAsync, updateMaterialPositionAsync } from './MaterialThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const materialSlice = createSlice({
    name: 'materials',
    initialState,
    reducers: {
        updateWorkOrder: (state, action) => {
            state.material = action.payload;
        },
        setSelectedWorkorderMaterialItemsList: (state, action) => {
            state.SelectedWorkorderMaterialsList = action.payload;
        },
        clearSelectedWorkorderMaterialItemsList: (state) => {
            state.SelectedWorkorderMaterialsList = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllMaterialByWorkOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllMaterialByWorkOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.materials = action.payload;
        })
            .addCase(getAllMaterialByWorkOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getHoursAndMaterialByIDAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getHoursAndMaterialByIDAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.material = action.payload;
        })
            .addCase(getHoursAndMaterialByIDAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createMaterialAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createMaterialAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.material = action.payload;
        })
            .addCase(createMaterialAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateMaterialAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateMaterialAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.material = action.payload;
        })
            .addCase(updateMaterialAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteMaterialAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteMaterialAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteMaterialAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateMaterialPositionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateMaterialPositionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateMaterialPositionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBulkMaterialAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBulkMaterialAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            //state.QuotationAmounts = action.payload;
        })
            .addCase(updateBulkMaterialAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { updateWorkOrder, setSelectedWorkorderMaterialItemsList, clearSelectedWorkorderMaterialItemsList } = materialSlice.actions;
export default materialSlice.reducer;
